import { ALEX_PHOTO, SITE } from "@/data/site";

export default function MeetTheTeam() {
  return (
    <section className="py-24 md:py-32 bg-[#F5F0EA] grain relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5 relative h-[460px] md:h-[600px]">
          <div className="absolute inset-0 overflow-hidden">
            <img
              src={ALEX_PHOTO}
              alt="Alex Moore, head wedding videographer and photographer in Essex"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute bottom-6 left-6 bg-[#F5F0EA] px-5 py-4 border border-stone-300">
            <p className="overline text-stone-500 mb-1">Founder · Head Videographer</p>
            <p className="font-serif text-2xl text-stone-900">Alex Moore</p>
          </div>
        </div>

        <div className="md:col-span-7 md:pl-12">
          <p className="overline mb-5">Meet Alex</p>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.04] tracking-tight text-stone-900">
            One person.
            <span className="italic text-stone-700"> Start to finish.</span>
          </h2>
          <p className="mt-7 text-stone-600 text-lg leading-relaxed max-w-xl">
            From your very first message to the moment you watch your finished film, Alex is with you
            the whole way. No call centres. No being passed around. Just one person who genuinely
            cares about getting your day right.
          </p>
          <p className="mt-5 text-stone-600 text-lg leading-relaxed max-w-xl">
            He founded Wedding Video Essex in {SITE.founded} because he believes every couple
            deserves a film that makes them feel it all again. Over 1000 happy couples later, he still
            gets emotional watching the final edits.
          </p>
          <div className="mt-8 flex flex-wrap gap-6">
            <div className="border-l border-stone-300 pl-4">
              <p className="overline text-stone-500 mb-1">Weddings filmed</p>
              <p className="font-serif text-3xl text-stone-900 kbd">1000+</p>
            </div>
            <div className="border-l border-stone-300 pl-4">
              <p className="overline text-stone-500 mb-1">Years filming weddings</p>
              <p className="font-serif text-3xl text-stone-900 kbd">12</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
